import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { formatNumber } from "../../utilities/helpers";

import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

export default function PackagePurchaseChart({ data, jsonData }) {
  if (!data) return "";

  const options = {
    chart: {
      type: "bar",
      height: 39,
      margin: [0, 0, 0, 0], // top, right, bottom, left
      background: "#fcfcfd",
      plotBackgroundColor: "#fcfcfd",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: [""],
      labels: {
        enabled: false,
      },
      stackLabels: {
        enabled: false,
      },
      lineWidth: 0,
      gridLineWidth: 0, // Disables grid lines on x-axis
      tickLength: 0,
      height: 40,
    },
    yAxis: {
      labels: {
        enabled: false,
      },
      stackLabels: {
        enabled: false,
      },
      min: 0,
      title: {
        text: "",
      },
      lineWidth: 0,
      gridLineWidth: 0, // Disables grid lines on y-axis
      tickLength: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        stacking: "percent",
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "Cash",
        data: [jsonData?.packagesCashTicketQty],
      },
      {
        name: "Card",
        data: [jsonData?.packagesCardTicketQty],
      },
    ],
  };
  return (
    <Card className="card--md stat-card card-with-border">
      <Card.Body className="d-flex-column flex-sm">
        <Card.Title as="h5">Packages</Card.Title>
        <HighchartsReact highcharts={Highcharts} options={options} />
        <ListGroup variant="flush">
          <ListGroup.Item className="d-flex justify-content-between border-bottom-0 small">
            <span className="info-text flex-sm info-text-dot info-text-dot--primary">
              Cash/Check
            </span>
            <span className="fw-medium">
              {formatNumber(jsonData?.packagesCashTicketQty)}
            </span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between border-bottom-0 small">
            <span className="info-text flex-sm info-text-dot info-text-dot--tertiary">
              Card
            </span>
            <span className="fw-medium">
              {formatNumber(jsonData?.packagesCardTicketQty)}
            </span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between small mt-auto">
            <span className="ms-2 fw-bold">Total</span>
            <span className="fw-bold">
              {formatNumber(
                jsonData?.packagesCashTicketQty +
                  jsonData?.packagesCardTicketQty,
              )}
            </span>
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
}
